import { Box, Stack, styled } from '@mui/material'
import { Outlet, Route, Routes } from 'react-router-dom'
import MyProfile from './MyProfile'
import { PageContainerStack } from 'components/Organization/EmailSettings'

const MainBox = styled(Box)`
  width: 100%;
`

const ProfileContainer = () => {
  return (
    <PageContainerStack>
      <Stack justifyContent="flex-start" direction="row">
        <MainBox>
          <Outlet />
        </MainBox>
      </Stack>
    </PageContainerStack>
  )
}

const UserProfile = () => {
  return (
    <Routes>
      <Route element={<ProfileContainer />}>
        <Route index element={<MyProfile />} />
      </Route>
    </Routes>
  )
}
export default UserProfile
